export const formatCypressTag = text =>
  (text || '').toString().toLowerCase().replace(/\s/g, '-');
